import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

type Data = {
  content: JSX.Element | null
  onClose: (() => void) | undefined
  hideDefaultCloseButton: boolean | undefined
}

type Actions = {
  setContent: (
    content: JSX.Element | null,
    opts?: {
      onClose?: () => void
      hideDefaultCloseButton?: boolean
    },
  ) => void
  close: () => void
}

export const initialState = {
  content: null,
  onClose: undefined,
  hideDefaultCloseButton: undefined,
} satisfies Data

type Store = Data & Actions

export const useModal = create<Store>()(
  immer((set) => ({
    ...initialState,
    close: () => set({ ...initialState }),
    setContent: (content, opts) => set({ content, ...opts }),
  })),
)
